export const shouldLoad = () => document.querySelector('.klt-table-cell--head-multi-select') !== undefined;